<template>
    <div class="tabela-scroll">
        <table class="tabela tabela-entregas" :aria-label="ariaLabel">
            <thead>
                <tr>
                    <th title="Estado do pacote de trabalho" />
                    <th>Projeto</th>
                    <th>Gerente</th>
                    <th title="Entrega vinculada ao pacote de trabalho">Entrega a ser alcançada</th>
                    <th>Pacote de trabalho</th>
                    <th>Coordenador do pacote de trabalho</th>
                    <th>Fim previsto</th>
                    <th class="col-status-th" title="Status do pacote de trabalho">Status</th>
                    <!-- <th>Observação</th> -->
                    <!-- <th>Resultado alcançado</th> -->
                    <th class="col-alertas">Alertas</th>
                    <th v-if="mostrarColunaFixar" class="col-fixar">
                        <span class="th-acao-label">Fixar</span>
                    </th>
                    <th v-if="mostrarColunaRepactuar" class="col-repactuar">
                        <span class="th-acao-label">Repactuar</span>
                    </th>
                    <th v-if="mostrarColunaValidar" class="col-selecionar">
                        <span class="th-acao-label">Validar</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="entrega in entregas" :key="chaveLinha(entrega)" class="linha-entrega"
                    :class="classeLinha(entrega)" role="button" tabindex="0" title="Abrir projeto na aba de pacotes de trabalho"
                    @click="$emit('abrir', entrega)" @keydown.enter="$emit('abrir', entrega)">
                    <td @click.stop>
                        <LegendaEstadoSprint :estado="estadoEntrega(entrega)" contexto="entrega" compacto />
                    </td>
                    <td :title="tituloProjetoCompleto(entrega)">
                        <span>
                            <template v-if="entrega.pcm_codigo">{{ entrega.pcm_codigo }} · </template>
                            {{ entrega.projeto_nome || '—' }}
                        </span>
                    </td>
                    <td :title="entrega.gerente_nome || ''">
                        <span>{{ entrega.gerente_nome || '—' }}</span>
                    </td>
                    <td :title="entrega.resultado_ser_alcancado || ''">
                        <!-- <span>{{ textoResumido(entrega.resultado_ser_alcancado) }}</span> -->
                        <span>{{ textoResumido(entrega.resultado_ser_alcancado) }}</span>
                    </td>
                    <td :title="entrega.entrega_nome">
                        <span>{{ entrega.entrega_nome }}</span>
                    </td>
                    <td :title="entrega.coordenador_nome || ''">
                        <span>{{ entrega.coordenador_nome || '—' }}</span>
                    </td>
                    <td>
                        <div class="fim-previsto">
                            <span v-if="!modoSemFim && entrega.fim_previsto">{{ formatarDataBr(entrega.fim_previsto)
                                }}</span>
                            <span v-else class="celula-vazia">—</span>
                            <span v-if="exibirFimPrevistoOriginal(entrega, entrega.fim_previsto)"
                                class="chip bg-erro fim-previsto-original"
                                :title="tituloFimPrevistoOriginal(entrega)">
                                Original: {{ formatarDataBr(fimPrevistoOriginal(entrega)) }}
                            </span>
                            <span v-if="repactuacaoPendente(entrega)" class="chip-repactuacao-pendente"
                                :title="tituloRepactuacaoPendente(entrega)">
                                Repactuação pendente
                            </span>
                        </div>
                    </td>
                    <td>
                        <div>
                            <span v-if="entrega.entrega_status" class="chip"
                                :class="classeStatusEntrega(entrega.entrega_status)"
                                :title="labelStatusEntrega(entrega.entrega_status)">
                                {{ labelStatusEntrega(entrega.entrega_status) }}
                            </span>
                            <span v-else class="celula-vazia">—</span>
                            <span v-if="entrega.aguardando_validacao" class="chip-aguardando-validacao"
                                title="Aguardando validação">
                                Aguard. valid.
                            </span>
                        </div>
                    </td>
                    <!-- <td class="celula-texto-longo" :title="entrega.observacao || ''">
                        <span >{{ textoResumido(entrega.observacao) }}</span>
                    </td> -->
                    <!-- <td class="celula-texto-longo" :title="entrega.resultado_alcancado || ''">
                        <span >{{ textoResumido(entrega.resultado_alcancado) }}</span>
                    </td> -->
                    <td @click.stop>
                        <v-menu v-if="entrega.avisos?.length" location="bottom start" :close-on-content-click="false"
                            max-width="420">
                            <template #activator="{ props: menuProps }">
                                <button type="button" class="btn-avisos-sprint acao-secundaria" v-bind="menuProps"
                                    :aria-label="`${entrega.avisos.length} alerta(s) do pacote de trabalho`">
                                    <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
                                    <span>{{ entrega.avisos.length }}</span>
                                </button>
                            </template>
                            <v-list density="compact" class="lista-avisos-sprint">
                                <v-list-subheader>Alertas do pacote de trabalho</v-list-subheader>
                                <v-list-item v-for="(aviso, idx) in entrega.avisos" :key="`${aviso.tipo}-${idx}`"
                                    :class="`aviso-item--${aviso.nivel}`">
                                    <template #prepend>
                                        <i class="bi aviso-item-icone" :class="iconeAviso(aviso.nivel)"
                                            aria-hidden="true"></i>
                                    </template>
                                    <v-list-item-title class="aviso-item-mensagem">{{ aviso.mensagem
                                        }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <span v-else class="celula-vazia">—</span>
                    </td>
                    <td v-if="mostrarColunaFixar" @click.stop>
                        <button type="button" class="acao-secundaria btn-fixar"
                            :class="{ 'btn-fixar--ativo': estaFixada(entrega) }"
                            :title="tituloBotaoFixar(entrega)" :aria-label="tituloBotaoFixar(entrega)"
                            :aria-pressed="estaFixada(entrega)"
                            @click="$emit('toggle-fixar', entrega)">
                            <i class="bi" aria-hidden="true"
                                :class="estaFixada(entrega) ? 'bi-pin-fill' : 'bi-pin'"></i>
                        </button>
                    </td>
                    <td v-if="mostrarColunaRepactuar" @click.stop>
                        <button type="button" class="acao-secundaria btn-repactuar"
                            :class="{ 'btn-repactuar--pendente': repactuacaoPendente(entrega) }"
                            :title="tituloBotaoRepactuar(entrega)" :aria-label="tituloBotaoRepactuar(entrega)"
                            @click="$emit('repactuar', entrega)">
                            <i class="bi bi-calendar-plus" aria-hidden="true"></i>
                        </button>
                    </td>
                    <td v-if="mostrarColunaValidar" @click.stop>
                        <button type="button" class="acao-secundaria btn-selecionar"
                            :class="{ 'btn-selecionar--ativo': estaSelecionada(entrega) }"
                            :disabled="validarDesabilitado(entrega)" :title="tituloBotaoValidar(entrega)"
                            :aria-label="tituloBotaoValidar(entrega)" :aria-pressed="estaSelecionada(entrega)"
                            @click="$emit('toggle-validar', entrega)">
                            <i class="bi" aria-hidden="true"
                                :class="estaSelecionada(entrega) ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { formatarDataBr } from '@/utils/date'
import { exibirFimPrevistoOriginal, fimPrevistoOriginal, tituloFimPrevistoOriginal } from '@/utils/fim-previsto-historico'
import {
    calcularEstadoEntrega,
    labelStatusEntrega,
    ICONE_AVISO_NIVEL,
} from '@/utils/sprintGestao'
import LegendaEstadoSprint from '@/components/Gestão/LegendaEstadoSprint.vue'

export default {
    name: 'EntregaGestaoTabela',

    components: { LegendaEstadoSprint },

    props: {
        entregas: {
            type: Array,
            default: () => [],
        },
        ariaLabel: {
            type: String,
            required: true,
        },
        modoSemFim: {
            type: Boolean,
            default: false,
        },
        ocultarColunaValidar: {
            type: Boolean,
            default: false,
        },
        selecionados: {
            type: Array,
            default: () => [],
        },
        repactuacoesPendentes: {
            type: Object,
            default: () => ({}),
        },
        mostrarColunaFixar: {
            type: Boolean,
            default: false,
        },
        permitirAcoesGestao: {
            type: Boolean,
            default: false,
        },
        entregasFixadas: {
            type: Array,
            default: () => [],
        },
    },

    emits: ['abrir', 'repactuar', 'toggle-validar', 'toggle-fixar'],

    computed: {
        mostrarColunaRepactuar() {
            return this.permitirAcoesGestao
        },
        /** Coluna Validar apenas em Entregas no período (não em blocos auxiliares). */
        mostrarColunaValidar() {
            return this.permitirAcoesGestao && !this.modoSemFim && !this.ocultarColunaValidar
        },
    },

    methods: {
        formatarDataBr,
        fimPrevistoOriginal,
        exibirFimPrevistoOriginal,
        tituloFimPrevistoOriginal,
        labelStatusEntrega,

        chaveLinha(entrega) {
            return this.modoSemFim ? `sem-fim-${entrega.entrega_id}` : entrega.entrega_id
        },

        classeLinha(entrega) {
            return `linha-entrega--${calcularEstadoEntrega(entrega)}`
        },

        estadoEntrega(entrega) {
            return calcularEstadoEntrega(entrega)
        },

        classeStatusEntrega(status) {
            if (status === 'Concluído') return 'bg-sucesso'
            if (status === 'Cancelada') return 'bg-erro'
            if (String(status).startsWith('Em andamento')) return 'bg-ok'
            return 'bg-alerta'
        },

        tituloProjetoCompleto(entrega) {
            const cod = entrega.pcm_codigo ? `${entrega.pcm_codigo} · ` : ''
            return `${cod}${entrega.projeto_nome || ''}`
        },

        iconeAviso(nivel) {
            return ICONE_AVISO_NIVEL[nivel] || ICONE_AVISO_NIVEL.info
        },

        textoResumido(texto, maximo = 80) {
            if (!texto) return '—'
            const valor = String(texto).trim()
            if (valor.length <= maximo) return valor
            return `${valor.slice(0, maximo)}…`
        },

        repactuacaoPendente(entrega) {
            return this.repactuacoesPendentes[Number(entrega.entrega_id)] || null
        },

        tituloRepactuacaoPendente(entrega) {
            const p = this.repactuacaoPendente(entrega)
            if (!p) return ''
            const data = formatarDataBr(p.dtFim)
            return this.modoSemFim
                ? `Será definido para ${data} ao salvar`
                : `Será alterado para ${data} ao salvar`
        },

        estaSelecionada(entrega) {
            return (this.selecionados || []).includes(Number(entrega.entrega_id))
        },

        validarDesabilitado(entrega) {
            return Boolean(this.repactuacaoPendente(entrega))
        },

        tituloBotaoRepactuar(entrega) {
            if (this.repactuacaoPendente(entrega)) {
                return 'Editar repactuação pendente'
            }
            return this.modoSemFim
                ? 'Definir fim previsto do pacote de trabalho'
                : 'Repactuar fim previsto do pacote de trabalho'
        },

        tituloBotaoValidar(entrega) {
            if (this.repactuacaoPendente(entrega)) {
                return 'Validação indisponível enquanto houver repactuação pendente'
            }
            if (this.estaSelecionada(entrega)) {
                return 'Remover da seleção para validar'
            }
            return 'Selecionar para validar'
        },

        estaFixada(entrega) {
            return (this.entregasFixadas || []).includes(Number(entrega.entrega_id))
        },

        tituloBotaoFixar(entrega) {
            return this.estaFixada(entrega)
                ? 'Desfixar pacote de trabalho'
                : 'Fixar pacote de trabalho (sempre visível nesta tela)'
        },
    },
}
</script>

<style scoped>
th,
td {
    text-align: left !important;
}

.celula-vazia {
    opacity: 0.45;
}

.fim-previsto {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
}

.fim-previsto-original {
    margin: 0;
    line-height: 20px;
    white-space: nowrap;
}

.tabela-entregas tbody tr.linha-entrega {
    cursor: pointer;
}

.tabela-entregas tbody tr.linha-entrega td:first-child {
    border-left: 6px solid transparent;
}

.tabela-entregas tbody tr.linha-entrega--ok td:first-child {
    border-left-color: var(--cor-sucesso, #2e7d32);
}

.tabela-entregas tbody tr.linha-entrega--aviso td:first-child {
    border-left-color: var(--cor-alerta, #f9a825);
}

.tabela-entregas tbody tr.linha-entrega--alerta td:first-child {
    border-left-color: var(--cor-erro, #c62828);
}

.tabela-entregas tbody tr.linha-entrega:focus-visible {
    outline: 2px solid var(--cor-primaria, #00b6b3);
    outline-offset: -2px;
}


.chip-repactuacao-pendente {
    font-size: 0.68rem;
    font-weight: 600;
    padding: 0.1rem 0.35rem;
    border-radius: 4px;
    background: hsl(45 90% 90%);
    color: hsl(35 75% 28%);
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chip-aguardando-validacao {
    font-size: 0.68rem;
    font-weight: 600;
    padding: 0.1rem 0.35rem;
    border-radius: 4px;
    background: hsl(130 40% 90%);
    color: var(--cor-sucesso, #2e7d32);
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.btn-repactuar,
.btn-selecionar,
.btn-fixar {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.25rem;
    min-height: 2.25rem;
    padding: 0.35rem !important;
    border-radius: 8px !important;
    border: 1px solid var(--cor-separador, rgba(0, 0, 0, 0.2)) !important;
    background: var(--cor-cinza, #f5f5f5) !important;
    color: var(--cor-fonte, #333) !important;
    font-size: 1.2rem;
    line-height: 1;
}

.btn-repactuar:hover,
.btn-selecionar:hover:not(:disabled),
.btn-fixar:hover {
    color: var(--cor-primaria, #00b6b3) !important;
    border-color: var(--cor-primaria, #00b6b3) !important;
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.12)) !important;
}

.btn-repactuar--pendente {
    color: var(--cor-primaria-forte, #008a88) !important;
    border-color: var(--cor-primaria, #00b6b3) !important;
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.18)) !important;
}

.btn-selecionar--ativo {
    color: var(--cor-sucesso, #2e7d32) !important;
    border-color: var(--cor-sucesso, #2e7d32) !important;
    background: hsl(130 40% 92%) !important;
}

.btn-fixar--ativo {
    color: var(--cor-primaria-forte, #008a88) !important;
    border-color: var(--cor-primaria, #00b6b3) !important;
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.18)) !important;
}

.btn-selecionar:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.btn-avisos-sprint {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    min-width: 2.5rem;
    min-height: 2.25rem;
    padding: 0.35rem 0.5rem !important;
    font-size: inherit;
    font-weight: 600;
    border-radius: 6px !important;
    flex-shrink: 0;
}

.lista-avisos-sprint {
    min-width: 16rem;
    max-width: 26rem;
}

.lista-avisos-sprint :deep(.v-list-item) {
    align-items: flex-start;
    min-height: auto;
    padding-top: 0.45rem;
    padding-bottom: 0.45rem;
}

.lista-avisos-sprint :deep(.aviso-item-mensagem) {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    line-height: 1.45;
    font-size: 0.875rem;
    word-break: break-word;
}

.lista-avisos-sprint .aviso-item--alerta {
    color: var(--cor-erro, #c62828);
}

.lista-avisos-sprint .aviso-item--aviso {
    color: hsl(35 75% 28%);
}

.lista-avisos-sprint .aviso-item--info {
    color: var(--cor-fonte-fraca, rgba(0, 0, 0, 0.55));
}

.lista-avisos-sprint .aviso-item-icone {
    margin-right: 0.25rem;
    flex-shrink: 0;
    margin-top: 0.1rem;
}
</style>
